"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLOW_ACTORS = exports.PartnerSessionType = void 0;
/**
 * Session type for the partner embed flow.
 *
 * @TranslateToPython
 */
var PartnerSessionType;
(function (PartnerSessionType) {
    PartnerSessionType["MLO"] = "MLO";
    PartnerSessionType["APPLICANT"] = "APPLICANT";
    PartnerSessionType["DASHBOARD"] = "DASHBOARD";
})(PartnerSessionType || (exports.PartnerSessionType = PartnerSessionType = {}));
/**
 * The session types that drive flows. DASHBOARD is excluded
 * because dashboard sessions don't run the iframe walker — they read inquiry state for display
 * only. The `actors` map on a v2 snapshot is keyed by FlowActor, not PartnerSessionType.
 * Shared with Python so declared here rather than in aven_backend.
 *
 * @TranslateToPython
 */
exports.FLOW_ACTORS = [PartnerSessionType.MLO, PartnerSessionType.APPLICANT];
